'use client';

/**
 * Saves one idea as a PDF using the browser's own "Save as PDF" print dialog — no server needed.
 * Marks the target section so the print styles show only that section (plus Willow's contact footer).
 */
export default function SavePdfButton({ targetId, label = 'Save as PDF' }: { targetId: string; label?: string }) {
  const save = () => {
    const el = document.getElementById(targetId);
    if (!el) return;
    el.setAttribute('data-print-target', '');
    document.body.setAttribute('data-printing', '');
    const cleanup = () => {
      el.removeAttribute('data-print-target');
      document.body.removeAttribute('data-printing');
      window.removeEventListener('afterprint', cleanup);
    };
    window.addEventListener('afterprint', cleanup);
    window.print();
  };

  return (
    <button
      type="button"
      onClick={save}
      className="print:hidden inline-flex items-center gap-2 border border-border px-4 py-2.5 text-xs font-semibold uppercase tracking-[0.08em] text-foreground transition-colors hover:border-primary hover:text-primary"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
        <path d="M12 3v12m0 0l-4-4m4 4l4-4M5 21h14" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      {label}
    </button>
  );
}
